import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility function to conditionally join CSS class names
 * Combines clsx and tailwind-merge for optimal class handling
 * @param inputs - Class values to be merged
 * @returns Combined and optimized class string
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Normalizes a name by trimming and collapsing multiple spaces into single space
 * @param name - The name string to normalize
 * @returns The normalized name string
 */
export function normalizeName(name) {
  return name ? name.trim().replace(/\s+/g, ' ') : "";
}
